import * as deviceDetect from "deviceDetect";

/** The body text's size at iOS's default text size */
const defaultBodySize = 17;
/** The narrowest iPhone's width, which every page fits */
const minPageWidth = 320;

/**
 * On iPhones, pages follow the text size chosen in iOS's Settings (Dynamic
 * Type), as `--text-size` (the scale from the default) zooming them
 * (app.scss): measured from the system's body font, which WebKit sizes
 * accordingly, and followed as it changes. Larger sizes zoom pages only as
 * far as `--max-zoom`, which leaves them `minPageWidth` across.
 */
export const follow = () => {
  if (!deviceDetect.is("iPhone")) {
    return;
  }
  const probe = document.createElement("span");
  probe.setAttribute("aria-hidden", "true");
  probe.style.cssText =
    "font: -apple-system-body; position: absolute; top: 0; left: 0; visibility: hidden; pointer-events: none";
  probe.textContent = "x";
  document.body.append(probe);

  const update = () => {
    const { style } = document.documentElement;
    style.setProperty(
      "--text-size",
      String(parseFloat(getComputedStyle(probe).fontSize) / defaultBodySize)
    );
    style.setProperty("--max-zoom", String(window.innerWidth / minPageWidth));
  };
  update();
  // (Not on iOS before 13.4, where an error here would leave pages blank)
  if ("ResizeObserver" in window) {
    new ResizeObserver(update).observe(probe);
  }
  // Turning the phone changes the room
  window.addEventListener("resize", update);
};
